<template>
    <div class="price-list">
      <h4 class="text-secondary font-weight-bold title-price-list">{{$t('provider_detail.price.name')}}</h4>
      <swiper v-if="services && services.length > 0" class="swiperPrices" :options="swiperPrices">
        <swiper-slide v-for="(service) in services" :key="service._id">
            <ul class="nav cursor-pointer" id="tab-prices" role="tablist" @click="selectService(service._id)">
                <li class="nav-item">
                    <a :title="service.category.name" class="nav-link pt-2 pb-2 d-flex justify-content-center align-items-center text-center w-100" :class="{'active': (selectedServiceId == service._id)}" >
                        {{translateCategory(service.category)}} 
                    </a>
                </li>
            </ul>
        </swiper-slide>
        <div class="swiper-scrollbar-price" slot="scrollbar"></div>
      </swiper>
      <p class="text-secondary">{{quotationsByServiceId.length >= 2 ? quotationsByServiceId.length + " "+$t('provider_detail.price.service') : quotationsByServiceId.length + " "+$t('provider_detail.price.service')}} </p>
        <div class="tab-content">
                <div class="row">
                  <div class="col-12 no-gutters d-flex justify-content-center" v-if="loading">
                      <span class="loading p-2" v-if="loading"></span>
                  </div>
                  <div class="col-12 no-gutters" v-else>
                    <div class="col-12 mb-3" v-for="quotation in quotationsByServiceId" :key="quotation._id">
                        <div v-if="quotation" id="card-quotation" class="card radius">
                            <div class="card-header bg-secondary font-weight-bold" :class="{radius: !quotation.description }" >
                                    <span class="d-block text-light quotation-name">{{quotation.name}}</span>
                                    <span v-if="!quotation.isNegotiable" class="d-block text-truncate text-primary price-size">{{ quotation.price | formatPriceVND }}<span class="text-unit font-weight-normal">VND</span></span>
                                    <span v-else class="d-block text-truncate text-primary price-size">{{$t('provider_detail.price.negotiable')}}</span>
                            </div>
                            <div v-if="quotation.description" class="card-body">
                                    <div class="mb-1 card-title text-secondary font-weight-bold">   
                                        <span class="text-secondary font-weight-bold">{{$t('provider_detail.price.more_detail')}}</span>
                                    </div>
                                    <p
                                      class="card-text"
                                    >
                                        {{quotation.description}}
                                    </p>
                                  </div>
                          </div>
                    </div>
                    <div v-if="quotationsByServiceId.length <= 0" class="col-12 text-black mb-3 pl-0">
                          {{$t('provider_detail.price.none')}}
                    </div>
                  </div>
             </div>  
        </div>
    </div>
</template>

<style scoped lang="scss">
.price-list{
  font-family: "Open Sans";
  font-size: 12px;
  .title-price-list{
    font-size: 16px;
    font-weight: 800;
  }

  .cursor-pointer{
    cursor: pointer;
  }

  .text-black{
     color: black;
  }

  .swiperPrices{
        #tab-prices{
            // height: 100%;
            .nav-item {
                // height: 40px;
                height: 100%;
                // width: 100%;
            }
            .nav-link{
                padding: 0px 15px 0px 0px;
                color: black;
                height: 100%;
                font-size: 12px;
            }
            .nav-link.active{
                font-size: 16px;
                font-weight: bold;
        }
     }
  }
  
  .radius {
    border-radius: 16px;
  }

  #card-quotation {
    border: none;
    .quotation-name{
      font-size: 14px;
    }
    .card-header {
        .price-size {
          position: relative;
          font-size: 18px;
        }
        .text-unit {
          position: absolute;
          color: #e9cc81;
          padding: 0px 1px;
          font-size: 10px;
        }
      }
  }

  .loading {
    margin: 20px;
    display: inline-block;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
     border-top: 5px solid #ffbe17;
    width: 30px;
    height: 30px;
    -webkit-animation: spin 0.9s linear infinite;
    animation: spin 0.8s linear infinite;
  }
  @-webkit-keyframes spin {
      0% {
          -webkit-transform: rotate(0deg);
      }
      100% {
          -webkit-transform: rotate(360deg);
      }
  }

  @keyframes spin {
      0% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(360deg);
      }
  }

  .swiper-slide {
    width: auto;
    height: auto;
    display: flex;
    max-width: 200px;
    // justify-content: center;
  }
  // .swiper-slide:nth-child(2n) {
  //   width: 32%;
  // }
  // .swiper-slide:nth-child(3n) {
  //   width: 30%;
  // }
  .swiper-scrollbar-price{
    cursor: pointer;
    left: 0;
    height: 6px;
    margin: 5px 0px;
  }

}
@media screen and (min-width: 1024px){
  .price-list{
    font-size: 14px;  
    .swiperPrices{
      #tab-prices{
        .nav-link{
            padding: 0px 15px 0px 0px;
            color: black;
            height: 100%;
            font-size: 14px;
         }
         .nav-link.active{
            font-size: 18px;
            font-weight: bold;
        }
      }
    }

    #card-quotation {
      .quotation-name{
        font-size: 16px;
      }
      .card-header {
          .price-size {
            font-size: 20px;
          }
          .text-unit {
            font-size: 14px;
          }
        }
    }
  }
}

</style>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "PriceList",
  props: {
    // providerId: String,
    services: Array
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data(){
    return {
      selectedServiceId: "",
      quotationsByServiceId: [],
      loading: false,
      quotations:[],
      // services: [],
      swiperPrices:{
        slidesPerView: 'auto',
        // spaceBetween: 30,
        // direction: 'horizontal',
        scrollbar: {
          el: '.swiper-scrollbar-price'
        },
        // slidesPerView: 3,
        // freeMode: true,
        // centeredSlides: true,
        // grabCursor: true,
        // loop: true,
        // slidesPerGroup: 3,
        // breakpoints:{
        //   1200:{
        //     slidesPerView: 2,
        //     spaceBetween: 10,
        //   },
        //   992: {
        //     slidesPerView: 2,
        //     spaceBetween: 9,
        //   },
        //   576:{
        //       slidesPerView: 2,
        //       spaceBetween: 9,
        //   },
        //   500:{
        //      slidesPerView: 2,
        //      spaceBetween: 9,
        //   },
        //   320: {
        //       slidesPerView: 1,
        //       spaceBetween: 9,
        //   }
        // }
      },
    }
  },
  filters:{
        formatPriceVND(value) {
            if(!value)
            {
            return 0;
            }
            // { style: 'currency', currency: 'VND' }
            return new Intl.NumberFormat('de-DE').format(value);
        },
  },
  methods: {
    translateCategory(category){
        if(localStorage && localStorage.language == 'vi'){
            return category.vietnameseName;
        }
        return category.name;
    },
    selectService(id){
        this.quotationsByServiceId = [];
        this.selectedServiceId = id;
        this.getQuotations(id).then(results =>{
          this.quotationsByServiceId = results;
        })
    },
     async getQuotations(serviceId) {
       this.loading = true;
      const {
        data: { results }
      } = await this.$store.$oddjob.serviceProviders.getQuotation(
        this.providerId,
        serviceId
      );
      if (results && results.length > 0) {
        this.loading = false;
        return results;
      }
      this.loading = false;
      return [];
    },
    // async getCategoryById(categoryId) {
    //   try {
    //     const {
    //       data: { results }
    //     } = await this.$store.$oddjob.settings.getCategoryById(categoryId);
    //     if (results && results.length > 0) {
    //       return results[0];
    //     }
    //     return {};
    //   } catch (e) {
    //     console.log("API category failed");
    //   }
    // },
    // async getCategoryById(providerId) {
    //   try {
    //     const {
    //       data: { results }
    //     } = await this.$store.$oddjob.serviceProviders.getServicesByProviderId(
    //       providerId
    //     );
    //     if (results && results.length > 0) {
    //       const data = results.map(async service => {
    //         service.category = await this.getCategoryById(service.category);
    //         return service;
    //       });
    //       return Promise.all(data);
    //     }
    //     return [];
    //   } catch (e) {
    //     console.log("API service failed", e);
    //   }
    // }
  },
  async mounted() {
    //  this.services = await this.getServicesByProviderId(this.providerId);
     if(this.services && this.services.length >0){
          this.selectService(this.services[0]._id);
          this.quotationsByServiceId = await this.getQuotations(this.services[0]._id);
      }
  }
}
</script>